module.exports = __webpack_public_path__ + "img/pro_thirteen_5.3f2840f6.jpg";